import { render, staticRenderFns } from "./CarrierHistory.vue?vue&type=template&id=01ef29bf&scoped=true&"
import script from "./CarrierHistory.vue?vue&type=script&lang=js&"
export * from "./CarrierHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ef29bf",
  null
  
)

export default component.exports